import {Component, computed, inject, Input} from '@angular/core';
import {UsersStore} from '../../users.store';
import {UsersFacade} from '../../users.facade';
import {UserProfileStore} from '../../../../core/auth/stores/user-profile.store';
import {Select} from 'primeng/select';
import {FormsModule} from '@angular/forms';
import {
	UserMailbox,
	USER_MAILBOX_ROLE_OPTIONS,
	USER_TENANT_ROLE_OPTIONS,
	UserRole
} from '../../../../core/auth/models/user.models';
import {Tag} from 'primeng/tag';
import {Divider} from 'primeng/divider';

@Component({
	selector: 'app-user-roles-panel',
	standalone: true,
	imports: [Select, FormsModule, Tag, Divider],
	templateUrl: './user-roles-panel.html'
})
export class UserRolesPanelComponent {
	@Input({ required: true }) userId!: string;

	private store = inject(UsersStore);
	private facade = inject(UsersFacade);
	private profileStore = inject(UserProfileStore);

	readonly tenantRoleOptions = USER_TENANT_ROLE_OPTIONS;
	readonly mailboxRoleOptions = USER_MAILBOX_ROLE_OPTIONS;

	private allowedTenantIds = computed(() =>
		this.profileStore.availableTenants().map((t: any) => t.tenant_id)
	);

	private targetUser = computed(() =>
		this.store.users().find(u => u.id === this.userId)
	);

	readonly visibleTenantRoles = computed(() => {
		const user = this.targetUser();
		if (!user) return [];

		const allowedIds = new Set(this.allowedTenantIds());
		const availableMailboxes = this.profileStore.availableMailboxes();

		return (user.user_tenant_roles ?? [])
			.filter((tr: any) => allowedIds.has(tr.tenant?.id))
			.map((tr: any) => {
				const tenantId = tr.tenant?.id;

				const mailboxRoles = availableMailboxes
					.filter((mb: UserMailbox) => mb.tenant_id === tenantId)
					.map((mb: UserMailbox) => {
						const existingRole = (user.user_mailbox_roles ?? [])
							.find((mr: any) =>
								mr.mailbox?.mailbox_alias === mb.mailbox_alias ||
								mr.mailbox?.mailbox_address === mb.mailbox_address
							);


						return {
							mailboxId:   mb.mailbox_id,
							mailboxName: mb.mailbox_name,
							role:        (existingRole?.role ?? null) as UserRole | null
						};
					});

				return {
					tenantId,
					tenantName:  tr.tenant?.name,
					role:        tr.role as UserRole,
					mailboxRoles
				};
			});
	});

	onTenantRoleChange(tenantId: string, newRole: UserRole) {
		this.facade.updateUserTenantRoleById(this.userId, tenantId, newRole);
	}

	onMailboxRoleChange(mailboxId: string, mailboxName: string, tenantId: string, newRole: UserRole) {
		this.facade.updateUserMailboxRoleById(this.userId, mailboxId, mailboxName, newRole);
	}
}
